
import { isEntrepreneur, isAnalist, isAdmin } from 'service/auth'

/**
 * This is the active logged in user, made available through Vuex
 */
let userModel = function ({
  name,
  email,
  faunaKey
}) {
  Object.assign(this, {
    name,
    email,
    faunaKey
  })
}

Object.defineProperty(userModel.prototype, "isAnalist", {
  get: isAnalist
});
Object.defineProperty(userModel.prototype, "isAdmin", {
  get: isAdmin
});
Object.defineProperty(userModel.prototype, "isEntrepreneur", {
  get: isEntrepreneur
});

export default userModel